export default __webpack_public_path__ + "static/media/table_Hk.6494af57.webp";